// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cGOE5","disabled":"styles_disabled__3D4tK"};